<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <img class="title_box pc" src="@/assets/images/img_aboutus.png" />

        <img
          class="title_box mobile"
          src="@/assets/images/img_aboutus_mobile.png"
        />
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
export default {
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 400px;
  background-color: #ecf3fa;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 0 20px 0px 20px;
  z-index: 1;
  padding: 30px;
  /* background-color: #f00; */
}

.title_box {
  width: 709px;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 400px;
    background-color: #ecf3fa;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 0 20px 0px 20px;
    z-index: 1;
    padding: 30px;
    /* background-color: #f00; */
  }

  .title_box {
    width: 272px;
  }
}
</style>
  